
export interface ColorType {
  '50': string;
  '100': string;
  '200': string;
  '300': string;
  '400': string;
  '500': string;
  '600': string;
  '700': string;
  '800': string;
  '900': string;
}
export type TColorTypeName = keyof ColorType;

export interface ThemeColor {
  gray: ColorType;
  yellow: ColorType;
  blue: ColorType;
  red: ColorType;
  green: ColorType;
  violet: ColorType;
  white: string;
}
export type TThemeColorName = keyof ThemeColor;

const color: ThemeColor = {
  gray: {
    50: '#FCFCFC',
    100: '#FAFAFA',
    200: '#F5F5F5',
    300: '#EDEDED',
    400: '#DFDFDF',
    500: '#CCCCCC',
    600: '#979797',
    700: '#656565',
    800: '#434343',
    900: '#222222',
  },
  yellow: {
    50: '#FCF5E3',
    100: '#FCEDC9',
    200: '#FCE7B0',
    300: '#FDE097',
    400: '#FDD164',
    500: '#FFB600',
    600: '#D79900',
    700: '#B37F00',
    800: '#7F5A00',
    900: '#4C3600',
  },
  blue: {
    50: '#EEF8FF',
    100: '#BAE0FF',
    200: '#89CEFF',
    300: '#00A9FF',
    400: '#008AFF',
    500: '#326CF9',
    600: '#1E41D0',
    700: '#152D92',
    800: '#0E2067',
    900: '#0C1A53',
  },
  red: {
    50: '#FFF4F4',
    100: '#FDD8DB',
    200: '#FA9DA4',
    300: '#F87680',
    400: '#F63C4A',
    500: '#E20724',
    600: '#A9051A',
    700: '#A10000',
    800: '#810000',
    900: '#600000',
  },
  green: {
    50: '#F3FAF8',
    100: '#DDF2EC',
    200: '#BBE5DA',
    300: '#76CAB5',
    400: '#5FC1A9',
    500: '#1CA885',
    600: '#16866A',
    700: '#10644F',
    800: '#0B4335',
    900: '#05211A',
  },
  violet: {
    50: '#F5F3FE',
    100: '#E2DEFE',
    200: '#BBB3FE',
    300: '#8B7CFD',
    400: '#6451FD',
    500: '#3E26FD',
    600: '#3817CA',
    700: '#2A1197',
    800: '#1C0B65',
    900: '#14084B',
  },
  white: '#ffffff',
};

export default color;
